import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const UPDATE_DIVISION = gql`
  mutation UpdateAccountDivision($input: UpdateAccountDivisionInput!) {
    updateAccountDivision(input: $input) {
      id
      name
      description
      video_url
      image
      image_id
    }
  }
`;

export function useUpdateDivision() {
  const [updateDivisionMutation, { loading }] = useMutation(UPDATE_DIVISION);

  const updateDivision = useCallback(
    async (input) => {
      try {
        const result = await updateDivisionMutation({
          variables: { input },
        });
        return { success: true, data: result.data?.updateAccountDivision };
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    [updateDivisionMutation]
  );

  return { updateDivision, loading };
}
